module.exports = __webpack_public_path__ + "static/media/sent.c746829a.svg";